import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TuiDialogContext } from '@taiga-ui/core';
import { injectContext } from '@taiga-ui/polymorpheus';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'app-chat-accessing-dialog',
  templateUrl: './chat-accessing-dialog.component.html',
  styleUrls: ['./chat-accessing-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatAccessingDialogComponent extends BaseResizableComponent {
  private readonly context = injectContext<TuiDialogContext<boolean>>();

  close() {
    this.context.completeWith(true);
  }
}
